var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 37.5L38.475 30L25.5 22.5V37.5ZM54.4 17.925C54.725 19.1 54.95 20.675 55.1 22.675C55.275 24.675 55.35 26.4 55.35 27.9L55.5 30C55.5 35.475 55.1 39.5 54.4 42.075C53.775 44.325 52.325 45.775 50.075 46.4C48.9 46.725 46.75 46.95 43.45 47.1C40.2 47.275 37.225 47.35 34.475 47.35L30.5 47.5C20.025 47.5 13.5 47.1 10.925 46.4C8.675 45.775 7.225 44.325 6.6 42.075C6.275 40.9 6.05 39.325 5.9 37.325C5.725 35.325 5.65 33.6 5.65 32.1L5.5 30C5.5 24.525 5.9 20.5 6.6 17.925C7.225 15.675 8.675 14.225 10.925 13.6C12.1 13.275 14.25 13.05 17.55 12.9C20.8 12.725 23.775 12.65 26.525 12.65L30.5 12.5C40.975 12.5 47.5 12.9 50.075 13.6C52.325 14.225 53.775 15.675 54.4 17.925Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "homepage/static/media/youtube.3c2b52725954c4e1cde8718109c5ab1e.svg";
export { ForwardRef as ReactComponent };